/* eslint-disable max-len */
import React, { useEffect, useState } from 'react';
import {
  Card,
  Col,
  Form,
  Row,
  Spin,
  Tabs,
  Button,
  Input,
  message,
} from 'antd';
import {
  SearchOutlined,
} from '@ant-design/icons';
import CustomSearch from 'components/customSearch';
import { getEmpleado, getEmpleadosConDatosOpFilteredPaginated, getEmpleadosFiltered } from 'api/estructuraOrganizacional/empleados';
import { getDatoOperacionalesDeEmpleados, getDatoOperacionalPorEmpleado } from 'api/estructuraOrganizacional/datosOperacionalesDeEmpleados';
import { getPuestos } from 'api/catalogos/puestos';
import { getCategoriasDePuestos } from 'api/catalogos/categoriaDePuestos';
import { getAdministracionDePlazas } from 'api/catalogos/admnistracionDePlazas';
import { getPlazas, getPlazasvistaOptimized, getPlazavistaOptimized } from 'api/catalogos/plazas';
import { getAreas } from 'api/catalogos';
import { getLiquidacionesEmpleados } from 'api/nominas/liquidaciones/liquidacionesEmpleados';
import { checkToken } from 'api/utils';
import { getTiposDeDocumentos } from 'api/catalogos/tiposDeDocumentos';
import { formatReceived, formatReceivedValues } from 'utils/formatValues';
import { areaBuscar, normalizeData } from 'utils/normalizers';
import TabPane from 'antd/lib/tabs/TabPane';
import { getEstadosCiviles, getGeneros } from 'api/usuarios';
import { getEstadosDeEmpleados } from 'api/estructuraOrganizacional/estadosDeEmpleados';
import { getTiposDeEmpleados } from 'api/catalogos/tiposDeEmpleados';
import { getTiposDeNominasEmpleados } from 'api/nominas/catalogos/tiposNominasEmpleados';
import moment from 'moment/moment';
import Select from 'components/Select';
import ExpedienteDatosOperacionales from './ExpedienteDatosOperacionales';
import ExpedienteDatosPersonales from './ExpedienteDatosPersonales';
import ExpedienteDocumentosEmpleados from './ExpedienteDocumentosEmpleados';
import ExpedienteVacaciones from './ExpedienteVacaciones';
import ExpedienteRetenciones from './ExpedienteRetenciones';
import ExpedienteSuspensiones from './ExpedienteSuspensiones';
import ExpedientePermisos from './ExpedientePermisos';
import ExpedienteMovimientosEmpleado from './ExpedienteMovimientosEmpleado';
import ExpedienteComentarios from './ExpedientesComentarios';
import ExpedienteIncapacidades from './ExpedienteIncapacidades';
import ExpedienteLiquidaciones from './ExpedienteLiquidaciones';
import ExpedienteDirecciones from './ExpedienteDirecciones';
import ExpedienteNombramientos from './ExpedienteNombramientos';
import ExpedienteJornadas from './ExpedienteJornadas';
import ExpedienteSindicatos from './ExpedienteSindicatos';

const ExpedienteDelEmpleado = () => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [empleados, setEmpleados] = useState([]);
  const [datosOperacionales, setDatosOperacionales] = useState([]);
  const [puestos, setPuestos] = useState([]);
  const [categoriasPuestos, setCategoriasPuestos] = useState([]);
  const [adminPlazas, setAdminPlazas] = useState([]);
  const [plazas, setPlazas] = useState([]);
  const [areas, setAreas] = useState([]);
  const [liquidacionesEmpleados, setLiquidacionesEmpleados] = useState([]);
  const [documentos, setDocumentos] = useState([]);
  const [estadosDeEmpleados, setEstadosDeEmpleados] = useState([]);
  const [generos, setGeneros] = useState([]);
  const [estadosCiviles, setEstadosCiviles] = useState([]);
  // const [tiposDeEmpleados, setTiposDeEmpleados] = useState([]);
  // const [tiposDeNominaEmpleado, setTiposDeNominaEmpleado] = useState([]);
  const [currentEmpleado, setCurrentEmpleado] = useState();
  const [datoOperacional, setDatoOperacional] = useState([]);
  const [currentParentTabKey, setCurrentParentTabKey] = useState('datos_personales');
  const [currentTabKey, setCurrentTabKey] = useState('movimientos');
  // const [open, setVisible] = useState(false);
  // const [data, setData] = useState([]);
  // const [baseURIPagination, setBaseURIPagination] = useState();
  // const [selectedEmpleado, setSelectedEmpleado] = useState();

  // let baseURI = 'catalogos/dato-operacional-del-empleado-paginado/?empleados_filter=';

  // const formatReceivedClone = (values) => {
  //   if (Array.isArray(values)) {
  //     let valueClone = values.map((e) => formatReceivedValues(e));
  //     valueClone = valueClone.map((e) => ({
  //       ...e,
  //     }));
  //     return valueClone;
  //   }
  //   return formatReceivedValues(values);
  // };

  const nameEmpleado = 'empleado';

  useEffect(() => {
    let mounted = true;
    const fetchAll = async () => {
      setLoading(true);
      await checkToken();
      const [
        _empleados,
        _plazas,
        _liquidacionesEmpleados,
        _documentos,
        _generos,
        _estadosCiviles,
        _estadosDeEmpleados,
        _datosOperacionales,
      ] = await Promise.all([
        getEmpleadosFiltered(),
        getPlazasvistaOptimized(),
        getLiquidacionesEmpleados(),
        getTiposDeDocumentos(),
        getGeneros(),
        getEstadosCiviles(),
        getEstadosDeEmpleados(),
        getDatoOperacionalesDeEmpleados(),
      ]);
      if (mounted) {
        setEmpleados(formatReceived(_empleados));
        setPlazas(_plazas);
        setLiquidacionesEmpleados(_liquidacionesEmpleados);
        setDocumentos(_documentos);
        setGeneros(_generos);
        setEstadosCiviles(_estadosCiviles);
        setEstadosDeEmpleados(_estadosDeEmpleados);
        setDatosOperacionales(_datosOperacionales);
        setLoading(false);
      }
    };
    fetchAll();
    return () => { mounted = false; };
  }, []);

  const onChangeEmpleado = async (val) => {
    setCurrentParentTabKey('datos_personales');
    setCurrentTabKey('movimientos');
    setCurrentEmpleado(val);

    if (!val) {
      setCurrentEmpleado(undefined);
      setDatoOperacional(undefined);
      form.resetFields();
      return;
    }

    try {
      const empleado = await getEmpleado(val);
      const datoOp = datosOperacionales?.find((e) => e.empleado === val);
      const idPlaza = datoOp?.plaza;
      const plaza = plazas?.find((p) => p.id === idPlaza);

      setDatoOperacional(datoOp);

      const fieldsValues = {
        // Datos Operacionales desde `plaza`
        tipo_empleado: plaza?.tipo_de_empleado,
        tipo_nomina_empleado: plaza?.tipo_nomina_empleado,
        area_content_id: plaza?.directorio_area_clave_y_nombre,
        puesto: plaza?.puesto_clave_y_descripcion,
        categoria_puesto: plaza?.categoria_de_empleado,
        sueldo_mensual: datoOp?.sueldo_mensual,
        plaza: plaza?.clave_y_descripcion,
        fecha_alta: datoOp?.fecha_de_alta ? moment(datoOp.fecha_de_alta) : null,
        fecha_baja: datoOp?.fecha_de_baja ? moment(datoOp.fecha_de_baja) : null,
        fecha_reingreso: datoOp?.fecha_de_reingreso ? moment(datoOp.fecha_de_reingreso) : null,
        clave_liquidacion: liquidacionesEmpleados.find((e) => e.empleado === val)?.clave || null,

        // Datos Personales
        rfc: empleado?.RFC,
        telefono: empleado?.numero_de_celular,
        genero: generos.find((e) => e.id === empleado?.genero)?.descripcion,
        domicilio: `${empleado?.calle_principal || ''} ${empleado?.numero_exterior || ''} ${empleado?.colonia || ''}`,
        curp: empleado?.curp,
        no_seguridad_social: empleado?.numero_de_seguridad_social,
        estado_civil: estadosCiviles.find((e) => e.id === empleado?.estado_civil)?.descripcion,
        estado_del_empleado: estadosDeEmpleados.find((e) => e.id === empleado?.estado_del_empleado)?.descripcion,
      };

      form.setFieldsValue(fieldsValues);
    } catch (error) {
      Error('Error al cambiar empleado:', error);
    }
  };

  // const validateInput = async () => {
  //   setLoading(true);
  //   setSelectedEmpleado();
  //   const searchEmp = form.getFieldValue('empleado');
  //   if (!searchEmp) {
  //     setVisible(true);
  //     return setLoading(false);
  //   }
  //   const res = await getEmpleadosConDatosOpFilteredPaginated(`${baseURI}numero_de_empleado=${searchEmp};`);
  //   const result = res?.results[0];
  //   if (!res) {
  //     return setLoading(false);
  //   }
  //   const empleadoResult = result?.empleado;
  //   setSelectedEmpleado(empleadoResult);
  //   // form.setFieldsValue({
  //   //   empleado: `${empleadoResult?.numero_de_empleado || ''} - ${empleadoResult?.nombre || ''} ${empleadoResult?.apellido_paterno || ''} ${empleadoResult?.apellido_materno || ''}`,
  //   // });
  //   onChangeEmpleado(empleadoResult?.id);
  //   return setLoading(false);
  // };

  // const searchData = async (empId, nombreEmp, apPatEmp, apMatEmp, tipoNominaEmpleado) => {
  //   setLoading(true);
  //   if (empId) {
  //     baseURI = `${baseURI}numero_de_empleado=${empId};`;
  //   }
  //   if (nombreEmp) {
  //     baseURI = `${baseURI}nombre=${nombreEmp};`;
  //   }
  //   if (apPatEmp) {
  //     baseURI = `${baseURI}apellido_paterno=${apPatEmp};`;
  //   }
  //   if (apMatEmp) {
  //     baseURI = `${baseURI}apellido_materno=${apMatEmp};`;
  //   }
  //   if (tipoNominaEmpleado) {
  //     baseURI = `${baseURI}&tipo_de_nomina_empleado=${tipoNominaEmpleado}&`;
  //   }
  //   setBaseURIPagination(baseURI);
  //   const _empleados = await getEmpleadosConDatosOpFilteredPaginated(baseURI);
  //   setData(formatReceivedClone(_empleados));
  //   return setLoading(false);
  // };

  // const columns = [
  //   {
  //     titleText: 'No. de Empleado',
  //     dataIndex: 'empleado',
  //     key: 'empleado',
  //     width: 200,
  //     render: (empObject) => empObject?.numero_de_empleado,
  //   },
  //   {
  //     titleText: 'Nombre',
  //     dataIndex: 'empleado',
  //     key: 'empleado',
  //     width: 250,
  //     render: (empObject) => empObject?.nombre,
  //   },
  //   {
  //     titleText: 'Apellido Paterno',
  //     dataIndex: 'empleado',
  //     key: 'empleado',
  //     width: 250,
  //     render: (empObject) => empObject?.apellido_paterno,
  //   },
  //   {
  //     titleText: 'Apellido Materno',
  //     dataIndex: 'empleado',
  //     key: 'empleado',
  //     width: 250,
  //     render: (empObject) => empObject?.apellido_materno,
  //   },
  //   {
  //     titleText: 'Puesto',
  //     dataIndex: 'empleado',
  //     key: 'empleado',
  //     width: 300,
  //     // render: (empObject) => {
  //     //   const adminPlazaEmp = adminPlazas?.results.find((admP) => admP?.empleado === empObject?.id);
  //     //   const plazaEmp = plazas?.results.find((pl) => pl?.id === adminPlazaEmp?.plaza);
  //     //   const puestoEmp = puestos?.find((p) => p?.id === plazaEmp?.puesto);
  //     //   return `${puestoEmp?.descripcion || ''}`;
  //     // },
  //   },
  //   {
  //     titleText: 'Tipo de Nómina Empleado',
  //     dataIndex: 'tipo_de_nomina_empleado',
  //     key: 'tipo_de_nomina_empleado',
  //     width: 250,
  //     render: (tneEmp) => tiposDeNominaEmpleado?.find((tne) => tne?.id === tneEmp)?.descripcion,
  //   },
  // ];

  return (
    <Row className="container">
      <Spin tip="Cargando..." spinning={loading}>
        <Card
          className="form-container"
          title="Expediente del Empleado"
          bordered={false}
        >
          <Form
            layout="vertical"
            form={form}
            scrollToFirstError
            name="general"
          >
            <Row gutter={10}>
              <Col xs={24} sm={24} md={8}>
                <Form.Item
                  name={nameEmpleado}
                  label="No. y Nombre del Empleado"
                  required
                  hasFeedback
                >
                  <Select
                    labelProp="numero_y_nombre_completo"
                    dataSource={empleados}
                    onChange={onChangeEmpleado}
                  />
                </Form.Item>
              </Col>
              {/* <Col xs={24} sm={24} md={8}>
                <Row align="middle">
                  <Col xs={24} sm={24} md={24}>
                    <div style={{ display: 'flex', alignItems: 'center', width: '100%' }}>
                      <Form.Item
                        label="No. y Nombre del Empleado"
                        name="empleado"
                        hasFeedback
                      >
                        <Input
                          allowClear
                        />
                      </Form.Item>
                      <Button
                        loading={loading}
                        onClick={validateInput}
                        icon={<SearchOutlined />}
                        style={{
                          width: '2.7rem',
                          marginTop: '-2px',
                        }}
                      />
                    </div>
                  </Col>
                </Row>
              </Col>
              <CustomSearch
                form={form}
                open={open}
                setVisible={setVisible}
                modalTitle="Buscar Empleado"
                firstInputLabel="No. de Empleado"
                firstInputName="numero_de_empleado"
                secondInputLabel="Nombre del Empleado"
                secondInputName="nombre"
                searchInputLabel="Apellido Paterno"
                searchInputName="apellido_paterno"
                thirdInputLabel="Apellido Materno"
                thirdInputName="apellido_materno"
                firstSelectLabel="Tipo de Nómina Empleado"
                firstSelectName="tipo_de_nomina_empleado"
                firstSelectDataSource={tiposDeNominaEmpleado}
                inputsNeeded={3}
                selectsNeeded={1}
                paginatedTable
                modalWidth={1400}
                columns={columns}
                baseURI={baseURIPagination}
                setSelectedRow={setSelectedEmpleado}
                onFinishGet={getEmpleadosConDatosOpFilteredPaginated}
                formatReceivedClone={formatReceivedClone}
                data={data}
                setData={setData}
                searchData={searchData}
                onChange={onChangeEmpleado}
              /> */}
              {/* {selectedEmpleado
                ? (
                  form.setFieldsValue({
                    empleado: `${selectedEmpleado?.numero_de_empleado || ''} - ${selectedEmpleado?.nombre || ''} ${selectedEmpleado?.apellido_paterno || ''} ${selectedEmpleado?.apellido_materno || ''}`,
                  })
                ) : null} */}
            </Row>
          </Form>
          <Tabs
            type="card"
            activeKey={currentParentTabKey}
            onChange={setCurrentParentTabKey}
          >
            <TabPane
              key="datos_personales"
              tab="Datos Personales"
            >
              <ExpedienteDatosPersonales
                form={form}
              />
            </TabPane>
            <TabPane
              key="datos_operacionales"
              tab="Datos Operacionales"
            >
              <ExpedienteDatosOperacionales
                form={form}
              />
            </TabPane>
            <TabPane
              key="documentos"
              tab="Documentos"
            >
              <ExpedienteDocumentosEmpleados
                currentEmpleado={currentEmpleado}
                documentos={documentos}
              />
            </TabPane>
            <TabPane
              key="historicos"
              tab="Históricos"
            >
              <Tabs
                type="card"
                activeKey={currentTabKey}
                onChange={setCurrentTabKey}
              >
                <TabPane
                  key="movimientos"
                  tab="Movimientos"
                >
                  <ExpedienteMovimientosEmpleado
                    currentEmpleado={currentEmpleado}
                  />
                </TabPane>
                <TabPane
                  key="vacaciones"
                  tab="Vacaciones"
                >
                  <ExpedienteVacaciones
                    currentEmpleado={currentEmpleado}
                    datosOperacionales={datoOperacional}
                  />
                </TabPane>
                <TabPane
                  key="direcciones"
                  tab="Direcciones"
                >
                  <ExpedienteDirecciones
                    currentEmpleado={currentEmpleado}
                  />
                </TabPane>
                <TabPane
                  key="nombramientos"
                  tab="Nombramientos"
                >
                  <ExpedienteNombramientos
                    currentEmpleado={currentEmpleado}
                  />
                </TabPane>
                <TabPane
                  key="jornadas"
                  tab="Jornadas"
                >
                  <ExpedienteJornadas
                    currentEmpleado={currentEmpleado}
                  />
                </TabPane>
                <TabPane
                  key="sindicato"
                  tab="Sindicato"
                >
                  <ExpedienteSindicatos
                    currentEmpleado={currentEmpleado}
                  />
                </TabPane>
                <TabPane
                  key="incapacidades"
                  tab="Incapacidades"
                >
                  <ExpedienteIncapacidades
                    currentEmpleado={currentEmpleado}
                  />
                </TabPane>
                <TabPane
                  key="permisos"
                  tab="Permisos"
                >
                  <ExpedientePermisos
                    currentEmpleado={currentEmpleado}
                  />
                </TabPane>
                <TabPane
                  key="retenciones"
                  tab="Retenciones"
                  disabled
                >
                  <ExpedienteRetenciones
                    currentEmpleado={currentEmpleado}
                  />
                </TabPane>
                <TabPane
                  key="suspensiones"
                  tab="Suspensiones"
                  disabled
                >
                  <ExpedienteSuspensiones
                    currentEmpleado={currentEmpleado}
                  />
                </TabPane>
                <TabPane
                  key="liquidaciones"
                  tab="Liquidaciones"
                  disabled
                >
                  <ExpedienteLiquidaciones
                    currentEmpleado={currentEmpleado}
                  />
                </TabPane>
                <TabPane
                  key="comentarios"
                  tab="Comentarios"
                >
                  <ExpedienteComentarios
                    currentEmpleado={currentEmpleado}
                  />
                </TabPane>
              </Tabs>
            </TabPane>
          </Tabs>
        </Card>
      </Spin>
    </Row>
  );
};

export default ExpedienteDelEmpleado;
